import React from 'react';
import { Button } from '../../flayr-components/Button/Button';
import { Flex } from '../../flayr-components/Flex/Flex';
import { Modal } from '../../flayr-components/Modal/Modal';
import SlideIn from '../SlideIn/SlideIn';
import SuccessMsg from '../SuccessMsg/SuccessMsg';

interface ISuccessModalProps {
  open?: boolean;
  message?: React.ReactNode;
  slideIn?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  onClose?: (e?: any) => void;
}

const SuccessModal: React.FC<React.PropsWithChildren<ISuccessModalProps>> = ({
  open,
  onClose,
  message,
  slideIn,
  size = 'xs',
}) => {
  const Component = (slideIn && SlideIn) || Modal;
  return (
    <Component open={open} onClose={onClose} size={size}>
      <Flex column center className="pt-1 text-center">
        <SuccessMsg message={message} />
        <Button className="mt-5" size="lg" color="dark" onClick={onClose} block>
          Close
        </Button>
      </Flex>
    </Component>
  );
};
export default SuccessModal;
